import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import _ from 'lodash';

import Alert from '../../utils/Alert';

import CreateSession from '../../components/sessions/CreateSession';
import Spinner from '../../components/generics/Spinner';

import {
  createSession,
  createSessionSuccess,
  createSessionFailure,
  fetchRecipes,
  fetchRecipesSuccess,
  fetchRecipesFailure,
  fetchStations,
  fetchStationsSuccess,
  fetchStationsFailure
} from "../../store/sessions/actions";

import { DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class SessionContainer extends Component {
  constructor(props) {
    super(props);
    this.searchRecipes = _.debounce(this.handleSearchRecipes, DEBOUNCE_SEARCH);

    this.alertRef = React.createRef();

    this.state = {
      station: "",
      submitting: false,
      isLoadingItems: false,
      errors: [],
      recipe: null,
      recipeList: []
    }

  }

  componentDidMount() {
    this.props.fetchStations();
    this.props.fetchRecipes();
  }

  spliceError = (element) => {
    var errors = this.state.errors.slice();
    var index = errors.indexOf(element);
    if(index !== -1){
      errors.splice(index, 1);
    }
    return errors;
  };

  handleStationChange = (event) => {
    var errors = this.spliceError('station');
    this.setState({ station: event.target.value, errors});
  };

  handleRecipeChange = (recipe) => {
    this.setState({ recipe: recipe ? recipe : null});
  };

  handleSearchRecipes = (inputValue) => {
    this.props.fetchRecipes(inputValue);
  };

  submitSession = () => {
    this.setState({ submitting: true });
    var data = new FormData();
    if(this.state.station !== ""){
      data.append('station', this.state.station);
      if(this.state.recipe !== null){
        data.append('recipe', this.state.recipe.id);
      }
      this.props.createSession(data,this.props);
    }else{
      let index;
      let errors = this.state.errors.slice();
      if (this.state.station === "") {
        index = errors.indexOf('station');
        if(index === -1){
          errors.push('station');
        }
      }
      this.alertRef.current.sendAlert('Station is required!');
      this.setState({ submitting: false, errors});
    }
  };

  cancelSession = () => {
    this.props.history.push('/session/');
  };

  render() {
    if(this.props.stationsList.loading){
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <Spinner />
        </div>
      )
    } else  {
      return (
        <Fragment>
          <Alert ref={this.alertRef}/>
          <CreateSession
            stations={this.props.stationsList.stations.results}
            onStationChange={this.handleStationChange}
            onRecipeChange={this.handleRecipeChange}
            searchRecipes={this.searchRecipes}
            recipeValue={this.state.recipe}
            submitSession={this.submitSession}
            cancelSession={this.cancelSession}
            station={this.state.station}
            recipes = {this.props.recipes}
            errors={this.state.errors}
          />
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    stationsList: state.sessions.stationsList,
    recipes: state.sessions.recipeList,
  };
};

const mapDispatchToProps = (dispatch) => {
  const finished = (data,props) => {
    props.history.push('/session/' + data.id  + '/edit')
  }
  return {
    fetchStations: (props) => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
    fetchRecipes: (filter) => {
      dispatch(fetchRecipes(filter)).payload.then((response) => {
        dispatch(fetchRecipesSuccess(response.data))
      }, (error) => {
        dispatch(fetchRecipesFailure(error));
      });
    },
    createSession: (data,props) => {
      dispatch(createSession(data)).payload.then((response) => {
        finished(response.data,props)
        dispatch(createSessionSuccess(response.data))
      }, (error) => {
        dispatch(createSessionFailure(error));
      });
    },
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps)(withRouter(SessionContainer));
